import React, { useEffect, useState } from 'react';
import './ProfileBanner.css';
import PlayButton from '../components/PlayButton';
import MoreInfoButton from '../components/MoreInfoButton';
import { getProfileBanner } from '../queries/getProfileBanner';
import { ProfileBanner as ProfileBannerType } from '../types';

const ProfileBanner: React.FC = () => {
  const [bannerData, setBannerData] = useState<ProfileBannerType | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getProfileBanner();
        console.log("Final banner data received:", data); // For debugging
        setBannerData(data);
      } catch (error) {
        console.error("Failed to fetch profile banner:", error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!bannerData) {
    return <div>Banner data could not be loaded.</div>;
  }

  // This function now uses 'resumelink' and optional chaining '?' for safety
  const handlePlayClick = () => {
    if (bannerData.resumelink?.url) {
      window.open(bannerData.resumelink.url, '_blank');
    }
  };

  // This function now uses 'linkedinlink'
  const handleLinkedinClick = () => { 
    if (bannerData.linkedinlink) {
      window.open(bannerData.linkedinlink, '_blank');
    }
  };

  return (
    // This div now correctly sets the background image from your data
    <div
      className="profile-banner"
      style={{ backgroundImage: `url(${bannerData.backgroundimage?.url})` }}
    >
      <div className="banner-content">
        <h1 className="banner-headline" id='headline'>{bannerData.headline}</h1>
        
        {/* This now uses the correct 'profilesummary' property */}
        <p className="banner-description">
          {bannerData.profilesummary}
        </p>

        <div className="banner-buttons">
          <PlayButton onClick={handlePlayClick} label="Resume" />
          <MoreInfoButton onClick={handleLinkedinClick} label="Linkedin" />
        </div>
      </div>
    </div>
  );
};

export default ProfileBanner;